
import {
	Math as THREEMath,
	Vector3,
	Color,
	TextureLoader,
	Mesh,
	MeshLambertMaterial,
	MeshBasicMaterial,
	MeshStandardMaterial,
	CubeGeometry,
	PointLightHelper,
	HemisphereLightHelper,
	SpotLightHelper,
	DirectionalLightHelper,
	AxesHelper,
	//ObjectLoader,
	Matrix3,
	Object3D,
	Box3,
	BoxHelper,
	VideoTexture,
	MeshPhongMaterial
} from '../../../../src/js/three.module.js';

import { ObjectLoader } from '../../../utils/object-loader.js';

import {
	rotateAroundWorldAxis,
	roundVector
} from '../../GameTools.js';

import { ObjectClickHandler }       from '../../../utils/object-click-handler.js';

import { CommentsHandler }      from '../../services/CommentsService.js';
import UserActionHistoryService from '../../services/UserActionHistoryService.js';
import { buildMaterialParameters, createDefaultMaterial, createMaterialByImageUid, createMaterialByImageUrl, createTextureByImageUrl } from './utils.js';

import { createHemisphereGroundColor } from '../../../utils/colors.js';

import { BaseAdditionalObject } from './base-additional-object.js';
import { AdditionalObjectJSON } from './additional-object-json.js';

import { GameSceneService } from '../../services/game-scene.service.js';

import { getTextureLoader } from '../../../utils/loaders/loader-manager.js';

const textureLoader = /* new TextureLoader() */ getTextureLoader();

export class AdditionalObjectCube extends BaseAdditionalObject {

    constructor( width, height, depth, material = {}, opts = {} ) {

        //var texture_img_uid = material.$img_uid || undefined; 

        /** @TODO: Ota paremmin käyttöön */
        let { texture_img_uid, texture_img_url } = {
            texture_img_uid : undefined,
            texture_img_url: null,
            ...opts
        };

        if (typeof material.map == "object") {

            if (material.map.image) {

                if (material.map.isVideoTexture) {

                    texture_img_url = material.map.image.src;

                } else {

                    texture_img_url = material.map.image.src;
                }
            }

            // Jos tekstuuria yhä ladataan, ei kuvaa ole asetettu ja siten material.map.image on tyhjä
            if (!texture_img_url && material.texture_img_url) {
                texture_img_url = material.texture_img_url;
            }

            // Jos tekstuuria yhä ladataan, ei kuvaa ole asetettu ja siten material.map.image on tyhjä
            if (!texture_img_uid && material.texture_img_uid) {
                texture_img_uid = material.texture_img_uid;
            }
        }

        if (!material.isMaterial) material = new MeshStandardMaterial( material );

        let materials = material;
        
        {
           materials = [ material.clone(), material.clone(), material.clone(), material.clone(), material.clone(), material.clone() ];
        }

        super( new Mesh( new CubeGeometry( 1, 1, 1 ), materials ));
        
        this.type = "cube";

        this.opts = {
            width           : width,
            height          : height,
            depth           : depth,
            color           : material.color && ("#"+material.color.getHexString()),
            texture_img_uid : texture_img_uid,
            texture_img_url : texture_img_url
        };

        this.opts.uuid = this.mesh.uuid;

        this.setWireframe();

        this.mesh.add( this.wireframe );

        this.onSelectChange();
        this.optsChanged();

        /** @note: purkkakorjaus tekstuurin asettamattajättämiseen -M 17.12.2019 */
        if (this.opts.texture_img_uid) {
            //this.mesh.material.$img_uid = null;
            this.setTexture( this.opts.texture_img_uid );
        }
    }

    /**
     *
     */
    static fromOpts( opts ) {
        var material = { color: new Color( opts.color ) };
        let { texture_img_uid } = opts;

        if (texture_img_uid) {

            material = createMaterialByImageUid( texture_img_uid );
            
            //material.$img_uid = opts.texture_img_uid;

        } else if (opts.texture_img_url) {

            material = createMaterialByImageUrl( opts.texture_img_url );

        }

        var obj = new AdditionalObjectCube( opts.width, opts.height, opts.depth, material, { texture_img_uid });

        if (opts.uuid) obj.changeUuid( opts.uuid );

        return obj;
    }

    /**
     *
     */
    static genHash( obj ) {

        return obj.type +
            "-" + obj.opts.width +
            "-" + obj.opts.height +
            "-" + obj.opts.depth +
            "-" + (obj.opts.texture_img_uid ||obj.opts.texture_img_url || obj.opts.color);
    }

    setTexture( img_uid ) {

        this.setTextureImageUid( img_uid );
    }

    setTextureImageUid( img_uid ) {

        //if (this.mesh.material.$img_uid == img_uid) return;
        //if (this.opts.texture_img_uid == img_uid) return;

        var material;
        var parameters = {
            map       : img_uid ? textureLoader.load( "/i/"+ img_uid +"?size=512x512!" ) : null,
            alphaTest : 0.1,
            opacity   : 1.0,
        };

        try {
            if (this.mesh.material) {
                material = new (this.getPrimaryMeshMaterial()).constructor( parameters );
            }
        } catch (error) {
            console.error( error );
        }

        if (!material) material = new MeshLambertMaterial( parameters );

        this.opts.texture_img_uid = img_uid;

        this.setMeshMaterial( material );
        this.setMeshMaterialColor( 0xffffff );
    }

    setTextureImageUrl( image_url ) {

        let parameters = buildMaterialParameters({
    
            map: createTextureByImageUrl( image_url )
    
        });
        
        let material;

        try {
            if (this.mesh.material) {
                material = new (this.getPrimaryMeshMaterial()).constructor( parameters );
            }
        } catch (error) {}

        if (!material) material = createDefaultMaterial( parameters );
        
        this.setMeshMaterial( material );
        this.setMeshMaterialColor( 0xffffff );
    }

    optsChanged() {
        this.width  = parseFloat( this.opts.width );
        this.height = parseFloat( this.opts.height );
        this.depth  = parseFloat( this.opts.depth );

        this.size = (this.size || new Vector3()).set( this.width, this.height, this.depth );

        this.mesh.scale.set( this.width, this.height, this.depth );

        this.updateMeshMaterial();

        this.refreshHash();
    }

    updateMeshMaterial() {

        if (this.opts.texture_img_uid) {

            this.setTextureImageUid( this.opts.texture_img_uid );

        } else {

            if (this.opts.texture_img_url && typeof this.opts.texture_img_url == "string") {

                this.setTextureImageUrl( this.opts.texture_img_url );

            } else {

		        this.setMeshMaterialMap( null );
            }

            
            this.setMeshMaterialColor( this.opts.color );
        }
    }

    setMeshMaterial( material ) {

        if (!material) return;

        let materials = this.getMeshMaterialArray();

        if (!materials) return;

        for (let i in materials) {
            materials[i].copy( material );
            materials[i].needsUpdate = true;
        }
    }

    setMeshMaterialMap( map ) {

        let materials = this.getMeshMaterialArray();

        if (!materials) return;

        for (let i in materials) {
            materials[i].map = map;
            materials[i].needsUpdate = true;
        }
    }

    setMeshMaterialColor( color ) {

        let materials = this.getMeshMaterialArray();

        if (!materials) return;

        if (!color) {
            return;
        } else if (color.isColor) {
            // ..
        } else {
            if (color[0] == "#") {
                color = parseInt( color.substring(1), 16 );
            }

            color = new Color( color );
        }

        for (let i in materials) {
            materials[i].color.copy( color );
            materials[i].needsUpdate = true;
        }
    }

    genHash() {
        return AdditionalObjectCube.genHash( this );
    }

    refreshHash() {
        var old_hash = this.obj_hash;

        this.obj_hash = this.genHash();

        if (old_hash != this.obj_hash) {
            let additionalObjectsService = this.service;
            additionalObjectsService.objectHashUpdateNeeded = true;
            // console.log("AdditionalObject.Cube.refreshHash() :: Hash changed!", old_hash, this.obj_hash, this);
        }
    }

    onSelectChange() {
        if (this.wireframe) this.wireframe.visible = (GameSceneService.getInstance().editor && this.selected) ? true : false;
    }

    setPlaceByIntersect( intersect ) {

        var point = AdditionalObjectJSON.prototype.setPlaceByIntersect.call( this, intersect );

        // Ohiteteaan muut toimenpiteet jos sijaintia ei voitu asettaa
        if (!point) return;

        GameSceneService.getInstance().shadowsNeedsUpdate = true;

        if (this.$lastNormal) {
            this.mesh.position.addScaledVector( this.$lastNormal, this.height/2 );
        }
    }

    rotateOnPlane( plus ) {

        if (isNaN(plus = plus || 0) || typeof plus != "number") throw "Invalid argument!";

        if (plus == 0) return;

        this.mesh.rotateY( plus );

        UserActionHistoryService.getInstance().do("additionalObject.move", this, null, this.mesh.rotation.clone());
    }
}